import React from "react";
import { useLogout } from "@hooks/useLogout";
import { KickLogo } from "@design-system/KickLogo/KickLogo";
import { Button, type ButtonSize } from "@design-system/Button/Button";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { LogoutIcon } from "@icons";
import {
    EXIT_ANIMATION_DURATION,
    ORGANIZATION_PREVIEW_URL,
    PRODUCT_PREVIEW_URL,
    FRESHBOOKS_SIDEBAR_URL,
} from "../constants";
import { ChildrenProps } from "../../../types";
import styles from "./BaseOnboardingContainer.module.scss";

const style = {
    "--exit-animation-duration": `${EXIT_ANIMATION_DURATION}ms`,
    "--preview-url": `url(${PRODUCT_PREVIEW_URL})`,
    "--organization-preview-url": `url(${ORGANIZATION_PREVIEW_URL})`,
    "--freshbooks-sidebar-url": `url(${FRESHBOOKS_SIDEBAR_URL})`,
} as any;

interface BaseOnboardingContainerProps extends ChildrenProps {
    logoutButtonSize?: Exclude<ButtonSize, "xs">;
}

export const BaseOnboardingContainer: React.FC<
    BaseOnboardingContainerProps
> = ({ children, logoutButtonSize = "md" }) => {
    const logout = useLogout();

    return (
        <div className={styles.container} style={style}>
            <KickLogo
                variant="icon"
                size="lg"
                label="Kick"
                className={styles.logo}
            />
            <div className={styles.mobileHeader}>
                <KickLogo variant="icon" size="lg" label="Kick" />
                <Tooltip content="Log out">
                    <Button
                        variant="secondary"
                        size={logoutButtonSize}
                        onClick={logout}
                        iconOnly
                        aria-label="Log out"
                    >
                        <LogoutIcon />
                    </Button>
                </Tooltip>
            </div>
            {children}
        </div>
    );
};
